import { render, staticRenderFns } from "./depot-tree.vue?vue&type=template&id=5f42417e&scoped=true&"
import script from "./depot-tree.vue?vue&type=script&lang=js&"
export * from "./depot-tree.vue?vue&type=script&lang=js&"
import style0 from "./depot-tree.vue?vue&type=style&index=0&id=5f42417e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f42417e",
  null
  
)

export default component.exports